import { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "@environments/environment";
import { SKIP_INTERCEPTORS } from "@shared/constants/http-context-tokens";

export function baseUrlInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  if (req.context.get(SKIP_INTERCEPTORS)) {
    return next(req);
  }

  const baseUrl = `${environment.shopwareHost}${environment.shopwarePath}`;
  const request = req.clone({ url: `${baseUrl}${req.url}` });
  return next(request);
}
